import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getProcessInstanceByCriteria(body = { keyword: '' }) {
        return Api().post('/ProcessInstance/GetProcessInstanceByCriteria', body);
    },
    /*  2. Get one column */
    getProcessInstance(id) {
        return Api().get(`/ProcessInstance/${id}`);
    },
    /*  3. Create one column */
    saveProcessInstance(body) {
        return Api().post(`/ProcessInstance`, body);
    },
    /*  4. Delete one or more columns */
    deleteProcessInstance(body) {
        return Api().post(`/ProcessInstance/DeleteProcessInstance`, body);
    },
    /*  5. post one or more columns */
    postProcessInstance(body) {
        return Api().post(`/ProcessInstance/PostProcessInstance`, body);
    },
    getMyRequest(body = { keyword: '' }) {
        return Api().post('/ProcessInstance/GetMyRequest', body);
    },
    approve(body) {
        return Api().post('/ProcessInstance/Approve', body);
    },
    Followup(body) {
        return Api().post('/ProcessInstance/Followup', body);
    },
    reject(body) {
        return Api().post('/ProcessInstance/Reject', body);
    },
    return(body) {
        return Api().post('/ProcessInstance/Return', body);
    },
    locked(body) {
        return Api().post('/ProcessInstance/Locked', body);
    },
    returnToApplicant(body) {
        return Api().post('/ProcessInstance/ReturnToApplicant', body);
    },
    /*  1. Get all instance user */
    GetPROCESSINSTANCEByApplicant(body = { keyword: '' }) {
        return Api().post('/ProcessInstance/GetPROCESSINSTANCEByApplicant', body);
    },
};
